<template>
  <b-card>
    <validation-observer v-slot="{ invalid }">
      <b-form>
        <b-row>
          <EntityEditSection
            :entity="entity"
            :form-fields="fields"
            module=""
            allow-autofocus
          />
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-0 mr-1"
              :disabled="invalid"
              @click.prevent="submitForm"
            >
              {{ $t('Save Changes') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="reset"
              class="mt-0"
              variant="outline-secondary"
              @click.prevent="reloadData"
            >
              {{ $t('Reset') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BRow, BCol, BCard,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import EntityEditSection from '@/layouts/entity/EntityEditSection.vue'

export default {
  components: {
    BButton,
    BForm,
    BRow,
    BCol,
    BCard,
    ValidationObserver,
    EntityEditSection
  },
  directives: {
    Ripple,
  },
  props: {
    userData: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      entity: JSON.parse(JSON.stringify(this.userData)),
      countryOptions: [],
      prefectureOptions: [],
    }
  },
  computed: {
    fields() {
      return [
        {
          id: 'country',
          object: true,
          type: 'select',
          label: this.$t('country'),
          options: this.countryOptions,
        },
        {
          id: 'prefecture',
          object: true,
          type: 'select',
          label: this.$t('prefecture'),
          options: this.prefectureOptions,
        },
        {
          id: 'city',
          label: this.$t('city'),
        },
        {
          id: 'region',
          label: this.$t('region'),
        },
        {
          id: 'address',
          label: this.$t('address'),
        },
        {
          id: 'postalCode',
          label: this.$t('postal code'),
        },
        {
          id: 'mobile',
          label: this.$t('mobile'),
          rules: 'phone',
        },
        {
          id: 'telephone',
          label: this.$t('telephone'),
          rules: 'phone',
        },
      ].map(field => ({
        ...field,
        type: field.type || 'text',
        parent: 'participant',
        class: 'mt-0',
        required: false,
        colSize: field.colSize || 6,
      }))
    },
  },
  mounted() {
    this.$store.dispatch('app-common/fetchCountries')
      .then(response => {
        this.countryOptions = response.data
      })
    this.$store.dispatch('app-common/fetchPrefectures').then((response) => {
      this.prefectureOptions = response.data
    })
  },
  methods: {
    reloadData() {
      this.entity = JSON.parse(JSON.stringify(this.userData))
    },

    submitForm() {
      this.$emit('formSubmitted', {
        ...this.entity,
      })
    },
  },
}
</script>
